import { render, staticRenderFns } from "./TechnicalFeaturesGarage.vue?vue&type=template&id=2e854ad4"
import script from "./TechnicalFeaturesGarage.vue?vue&type=script&lang=js"
export * from "./TechnicalFeaturesGarage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports